var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLiveAlarm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m12.826 11.025-1.338-2.108a.96.96 0 0 1-.15-.517V5.25C11.338 2.893 9.392.975 7 .975S2.662 2.893 2.662 5.25V8.4a.96.96 0 0 1-.15.517l-1.338 2.108zm.412.975H.762c-.598 0-.962-.648-.645-1.148L1.673 8.4V5.25C1.673 2.35 4.058 0 7 0s5.327 2.35 5.327 5.25V8.4l1.556 2.452c.317.5-.047 1.148-.645 1.148"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M4.646 11.247A.5.5 0 0 1 5 11.1h4a.5.5 0 0 1 .5.5c0 .376-.055.75-.163 1.103s-.268.68-.477.962a2.4 2.4 0 0 1-.758.681 1.94 1.94 0 0 1-.953.254h-.298c-.68 0-1.29-.366-1.71-.935-.42-.566-.641-1.31-.641-2.065a.5.5 0 0 1 .146-.354m.898.853c.067.374.208.71.4.97.273.369.605.53.907.53h.298q.231.002.464-.127a1.4 1.4 0 0 0 .443-.403 2.2 2.2 0 0 0 .325-.66q.046-.15.075-.31z",
  clipRule: "evenodd"
})));
export default SvgIconLiveAlarm;